import { api } from 'app/utils/api/helpers'

export const getTenantDetails = (id) => {
  return api.get(`/sm/properties/${id}/tenants`)
}
